import type { Block, EnvelopeRow } from './types';

export type Tone = 'good' | 'warning' | 'critical' | 'info';
type ToneRule = { above?: number; below?: number; tone: Tone };

const LINK_HOST = /^(?:[a-z0-9-]+\.)*luxuryescapes\.com$/;

export function linkFor(block: Block | undefined, column: string, row: EnvelopeRow): string | undefined {
  const template = (block?.links as Record<string, string> | undefined)?.[column];
  if (!template || row.other) return undefined;
  const href = template.replace(/\{([^}]+)\}/g, (_, name: string) => encodeURIComponent(String(row[name] ?? '')));
  try {
    const url = new URL(href);
    return url.protocol === 'https:' && LINK_HOST.test(url.hostname) ? href : undefined;
  } catch {
    return undefined;
  }
}

export function toneFor(block: Block | undefined, column: string, value: unknown): Tone | undefined {
  const rule = (block?.tones as Record<string, Record<string, Tone> | Array<ToneRule>> | undefined)?.[column];
  if (!rule || value === null || value === undefined) return undefined;
  if (!Array.isArray(rule)) return rule[String(value)];
  const number = Number(value);
  return rule.find((entry) => (entry.below === undefined || number < entry.below) && (entry.above === undefined || number > entry.above))?.tone;
}

export function columnGroups(block: Block | undefined): Array<{ label: string; columns: Array<string> }> {
  return (block?.groups as Array<{ label: string; columns: Array<string> }> | undefined) ?? [];
}
